import { jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { memo, forwardRef } from "react";
import { Box } from "../../Box/Box.js";
import { toStateClass } from "../../../utils/toStateClass.js";
const FileDropZone = memo(forwardRef(({
  isActive,
  isAccepting,
  isRejecting,
  className,
  ...props
}, ref) => {
  const componentClassName = useClassNameFactory("fileDropZone");
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...props,
      className: componentClassName(null, [
        toStateClass("active", isActive),
        toStateClass("accepting", isAccepting),
        toStateClass("rejecting", isRejecting),
        className
      ]),
      ref
    }
  );
}));
FileDropZone.displayName = "FileDropZone";
export {
  FileDropZone
};
//# sourceMappingURL=FileDropZone.js.map
